import { render, staticRenderFns } from "./cadguiasrotas.vue?vue&type=template&id=64b69a3a&"
import script from "./cadguiasrotas.vue?vue&type=script&lang=js&"
export * from "./cadguiasrotas.vue?vue&type=script&lang=js&"
import style0 from "./cadguiasrotas.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports